import dotenv from 'dotenv';

dotenv.config();

export const URL_VISTORIA = process.env.VUE_APP_URL_VISTORIA
  ? process.env.VUE_APP_URL_VISTORIA
  : 'https://vistoria.bpseguradora.com.br';

export const URL_CHECKOUT = process.env.VUE_APP_CHECKOUT_URL
  ? process.env.VUE_APP_CHECKOUT_URL
  : 'https://checkout.bpseguradora.com.br';

export const URL_DOCUMENTOS_VIDA = process.env.VUE_APP_DOCUMENTOS_VIDA_URL
  ? process.env.VUE_APP_DOCUMENTOS_VIDA_URL
  : 'https://documentos.bpseguradora.com.br';

export const URL_VISTORIA_VIDA = process.env.VUE_APP_URL_VISTORIA_VIDA
  ? process.env.VUE_APP_URL_VISTORIA_VIDA
  : 'http://127.0.0.1:3000';

export const MAX_BROKERAGE = process.env.VUE_APP_MAX_BROKERAGE
  ? Number(process.env.VUE_APP_MAX_BROKERAGE)
  : 35;

export const ORIGIN_SYSTEM = {
  BPSEG: 'bpseg',
};

export const TIPOS_APOLICES = {
  AUTO: 1,
  RCVAT: 2,
  VIDA: 3,
  MICRO_VIDA: 4,
};

export const FINANCIAL_STATUS = {
  OVERDUE: { label: 'Inadimplente', dueDays: -1 },
  DUE_TODAY: { label: 'Vence Hoje', dueDays: 0 },
  DUE_NEXT_DAYS: { label: 'Próximos Dias', dueDays: 3 },
};

export const STATUS_PURCHASE = {
  created: 'CRIADO',
  generated: 'GERADO',
  authorized: 'AUTORIZADO',
  underpaid: 'PAGO VALOR ABAIXO',
  overpaid: 'PAGO VALOR ACIMA',
  paid: 'PAGO',
  captured: 'CAPTURADO',
  canceled: 'RESTITUÍDO',
  partially_canceled: 'RESTITUÍDO PARCIALMENTE',
  with_error: 'COM ERRO',
  failed: 'FALHOU',
  notification_failed: 'NOTIFICAÇÃO FALHOU',
  processing: 'PROCESSANDO',
  denied: 'NEGADO',
};

export const LIFE_KINSHIP = {
  1: 'Avô(ó)',
  2: 'Bisneto(a)',
  3: 'Companheiro(a)',
  4: 'Esposo(a)',
  5: 'Filho(a)',
  6: 'Irmão(ã)',
  7: 'Mãe',
  8: 'Neto(a)',
  9: 'Pai',
  10: 'Primo(a)',
  11: 'Sobrinho(a)',
  12: 'Tio(a)',
  90: 'Próprio',
  99: 'Outros',
};

export const LIST_CNH = ['A', 'B', 'C', 'D', 'E', 'AB', 'AC', 'AD', 'AE'];

export const LIST_PESSOAS = ['Pessoa Física', 'Pessoa Jurídica'];

export const SOLTEIRO = 'Solteiro';
export const CASADO = 'Casado';
export const SEPARADO = 'Separado';
export const DIVORCIADO = 'Divorciado';
export const VIUVO = 'Viúvo';

export const LIST_SEXO = ['Masculino', 'Feminino'];

export const LIST_ESTADO_CIVIL = [
  SOLTEIRO,
  CASADO,
  SEPARADO,
  DIVORCIADO,
  VIUVO,
];

export const LIST_REGIME_CASAMENTO = [
  'Comunhão parcial de bens',
  'Comunhão universal de bens',
  'Separação de bens',
  'Pacto antenupcial',
];

export const ALL_BROKERS_OPTION = {
  LABEL: 'Todas as corretoras',
  ID: -1,
};

export const STATUS_PROPOSTA = {
  EM_TRANSMISSAO: { id: 1, name: 'Em Transmissão' },
  RECUSADA: {
    id: 2,
    name: 'Recusada',
  },
  AGUARDANDO_APROVACAO: {
    id: 3,
    name: 'Em Subscrição e Emissão',
  },
  FINALIZADO: {
    id: 4,
    name: 'Emitida',
  },
  PENDENTE: {
    id: 5,
    name: 'Correção de Vistoria',
  },
  EM_PROCESSO_VISTORIA: {
    id: 6,
    name: 'Aguardando Vistoria',
  },
  EM_PRE_ANÁLISE: {
    id: 7,
    name: 'Em Pré-Análise',
  },
  AGUARDANDO_DADOS_CARTAO: {
    id: 8,
    name: 'Aguardando Dados do Cartão',
  },
  AGUARDANDO_DOCUMENTACAO: {
    id: 9,
    name: 'Aguardando Documentação',
  },
  APOLICE_CANCELADA: {
    id: 10,
    name: 'Apólice Cancelada',
  },
  AGUARDANDO_ESTORNO: {
    id: 11,
    name: 'Aguardando Estorno',
  },
  ESTORNADA: {
    id: 12,
    name: 'Estornada',
  },
  COTACAO_ABERTA: {
    id: 13,
    name: 'Cotação Aberta',
  },
  COTACAO_CANCELADA: {
    id: 14,
    name: 'Cotação Cancelada',
  },
  COTACAO_RECUSADA: {
    id: 15,
    name: 'Cotação Recusada',
  },
  VISTORIA_EXPIRADA: {
    id: 16,
    name: 'Vistoria Expirada',
  },
  AGUARDANDO_PAGAMENTO: {
    id: 17,
    name: 'Aguardando Pagamento',
  },
  VALIDANDO_CI: {
    id: 18,
    name: 'Validando CI',
  },
  APOLICE_FINALIZADA: {
    id: 19,
    name: 'Apólice Finalizada',
  },
  PROCESSANDO_PAGAMENTO: {
    id: 20,
    name: 'Processando Pagamento',
  },
};

export const DATE_TYPES = [
  {
    id: 'quotation',
    label: 'Data da Cotação',
  },
  {
    id: 'proposal',
    label: 'Data da Proposta',
  },
  {
    id: 'inspection',
    label: 'Data da Vistoria',
  },
  {
    id: 'activation',
    label: 'Data da Emissão',
  },
  {
    id: 'coverage_start',
    label: 'Data de Início da Vigência',
  },
  {
    id: 'refusal',
    label: 'Data de Recusa/Cancelamento',
  },
];

export const CREATION_TYPES = [
  {
    id: 'new_policy',
    label: 'Seguro novo',
  },
  {
    id: 'endorsement',
    label: 'Endosso',
  },
];

export const POLICY_STATUSES = {
  OPEN: {
    id: 1,
    name: 'Aberto',
  },
  ACTIVE: {
    id: 2,
    name: 'Ativo',
  },
  OVERDUE: {
    id: 3,
    name: 'Inadimplente',
  },
  CANCELED: {
    id: 4,
    name: 'Cancelado',
  },
  INACTIVE: {
    id: 5,
    name: 'Inativo',
  },
  FINISHED: {
    id: 6,
    name: 'Finalizado',
  },
};

export const POLICY_REFUND_STATUSES = {
  DONE: 'Concluído',
  PENDING: 'Pendente',
};

export const PRODUCTS_GROUPING = {
  RCF: 'rcf',
  APP: 'app',
  COMPREHENSIVE: 'comprehensive',
  GLASS: 'glass',
  ASSISTANCE: '24h_assistance',
  SUBSTITUTE_VEHICLE: 'substitute_vehicle',
};

export const MESSAGING_SUCCESS_STATUS = [
  'Mensagem enviado com sucesso',
  'Email enviado com sucesso',
  'Whatsapp enviado com sucesso',
];

export const ID_MOTIVO_RECUSA_CORRETORA_PADRAO = 7;
export const OBSERVACAO_RECUSA_CORRETORA_PADRAO =
  'Recusa solicitada pela corretora';

export const PAYMENT_METHODS = {
  CREDIT_CARD: { id: 2, name: 'Cartão de Crédito' },
  BILLET: { id: 4, name: 'Boleto' },
  AUTOMATIC_DEBIT: { id: 5, name: 'Débito Automático' },
  PIX: { id: 6, name: 'Pix' },
};

export const ZERO_KM_VEHICLE_YEAR_ID = '32000';

export const CONGENERS = Object.freeze({
  NOT_RENEWAL: {
    label: 'Não',
    id: '1',
  },
  OTHER: {
    label: 'Sim, outra seguradora',
    id: '2',
  },
  BPSEG: {
    label: 'Sim, da BP SEGURADORA S.A.',
    id: '1546',
  }
});

export const TRANSLATE_GLASS_FRANCHISES = {
  rlp: 'Reparo de Lanternagem e Pintura',
  rps: 'Reparo de Pneus e Suspensão',
  farol: 'Farol',
  vigia: 'Vigia',
  lateral: 'Lateral',
  maquina: 'Maquina',
  auxiliar: 'Auxiliar',
  lanterna: 'Lanterna',
  parabrisa: 'Parabrisa',
  retrovisor: 'Retrovisor',
  inteligente: 'Inteligente',
  lanterna_led: 'Lanterna de Led',
  retrovisor_led: 'Retrovisor de Led',
  farol_xenon_led: 'Farol Xenon de Led',
};

export const PURCHASE_STATUS = {
  GENERATED: 'generated',
  AUTHORIZED: 'authorized',
  UNDERPAID: 'underpaid',
  OVERPAID: 'overpaid',
  PAID: 'paid',
  CAPTURED: 'captured',
  CANCELED: 'canceled',
  PARTIALLY_CANCELED: 'partially_canceled',
  WITH_ERROR: 'with_error',
  FAILED: 'failed',
  NOTIFICATION_FAILED: 'notification_failed',
  PROCESSING: 'processing',
  DENIED: 'denied',
};

export const TRANSLATED_POLICY_INSTALLMENT_STATUS = {
  paid: 'PAGO',
  underpaid: 'PAGO COM PENDÊNCIA',
  pending: 'PENDENTE',
  canceled: 'CANCELADO',
}
export const POLICY_INSTALLMENT_STATUS_ENUM = {
  PAID: 'paid',
  UNDERPAID: 'underpaid',
  PENDING: 'pending',
  CANCELED: 'canceled',
}

export const EDI_IMPORT_STATUS_ENUM = {
  CREATED: 'created',
  PROCESSING: 'processing',
  DONE: 'done',
  ERROR: 'error',
};

export const VEHICLE_TYPE_CODE_LABEL = {
  1: 'Carro',
  2: 'Moto',
  3: 'Caminhão',
};

export const OPCOES_SIM_NAO = [
  {
    id: 0,
    label: 'Não',
  },
  {
    id: 1,
    label: 'Sim',
  },
];
export const RoutineIntervalType = {
  EVERY_DAY_AT: 'every_day_at',
  EVERY: 'every',
};

export const RoutineIntervalTypeLabel = {
  [RoutineIntervalType.EVERY_DAY_AT]: 'Todo dia às',
  [RoutineIntervalType.EVERY]: 'A cada',
};

export const RoutineIntervalUnity = {
  SECONDS: 'seconds',
  MINUTES: 'minutes',
  HOURS: 'hours',
};

export const RoutineIntervalUnityLabel = {
  [RoutineIntervalUnity.SECONDS]: 'Segundos',
  [RoutineIntervalUnity.MINUTES]: 'Minutos',
  [RoutineIntervalUnity.HOURS]: 'Horas',
};

export const RoutineIntervalTypesOptions = [
  {
    label: RoutineIntervalTypeLabel[RoutineIntervalType.EVERY_DAY_AT],
    value: RoutineIntervalType.EVERY_DAY_AT,
  },
  {
    label: RoutineIntervalTypeLabel[RoutineIntervalType.EVERY],
    value: RoutineIntervalType.EVERY,
  },
];

export const RoutineIntervalUnitiesOptions = [
  {
    label: RoutineIntervalUnityLabel[RoutineIntervalUnity.SECONDS],
    value: RoutineIntervalUnity.SECONDS,
  },
  {
    label: RoutineIntervalUnityLabel[RoutineIntervalUnity.MINUTES],
    value: RoutineIntervalUnity.MINUTES,
  },
  {
    label: RoutineIntervalUnityLabel[RoutineIntervalUnity.HOURS],
    value: RoutineIntervalUnity.HOURS,
  },
];

export const ContractPdfEnum = {
  AUTO: 'auto',
  LIFE: 'life',
  QUOTATION_AUTO: 'quotation-auto',
  AUTO_QUOTATION_ENDORSEMENT: 'auto-quotation-endorsement',
  AUTO_POLICY_ENDORSEMENT: 'auto-policy-endorsement',
  AUTO_PROPOSAL_ENDORSEMENT: 'auto-proposal-endorsement',
};

export const TypeSavePdf = {
  QUOTATION: 'quotation',
  PROPOSAL: 'proposal',
  POLICY: 'policy',
};

export const PDF_DOCUMENT_TYPES = {
  QUOTATION: 'Cotação',
  PROPOSAL: 'Proposta',
  POLICY: 'Apólice',
  ENDORSEMENT_QUOTATION: 'Cotação do Endosso',
  ENDORSEMENT_POLICY: 'Apólice do Endosso',
  ENDORSEMENT_PROPOSAL: 'Proposta do Endosso',
};

export const PDF_SECTION_NAMES = {
  DATA: 'PDF - Dados da',
  DATA_ENDORSEMENT_PREVIOUS_POLICY: 'PDF - Apólice Anterior -',
  BROKER_DATA: 'PDF - Dados da Corretora -',
  INSURED: 'PDF - Segurado -',
  INSURED_ADDRESS: 'PDF - Endereço do Segurado -',
  RENEWAL: 'PDF - Renovação -',
  MAIN_DRIVER: 'PDF - Condutor Principal -',
  OVERNIGHT_ADDRESS: 'PDF - Endereço de Pernoite -',
  VEHICLE: 'PDF - Veículo -',
  RISK_QUESTIONNAIRE: 'PDF - Questionário de Avaliação de Risco -',
  COVERAGES: 'PDF - Coberturas -',
  SERVICES: 'PDF - Serviços -',
  FRANCHISE: 'PDF - Franquia -',
  PAYMENT: 'PDF - Pagamento -',
  INSTALLMENTS: 'PDF - Parcelamento -',
  GENERAL_PROVISIONS: 'PDF - Disposições Gerais -',
};

export const FORM_MESSAGES = {
  REQUIRED_FIELD: 'Preencha este Campo',
};

export const MAXPAR_MANUAL_ACTIONS = {
  CREATE: { value: 'Envio', label: 'Envio' },
  CHANGE: { value: 'Alteração', label: 'Alteração de dados' },
  CANCEL: { value: 'Cancelamento', label: 'Cancelamento' },
};

export const STAR_MANUAL_ACTIONS = {
  CREATE: { value: 'create', label: 'Envio' },
  CANCEL: { value: 'cancel', label: 'Cancelamento' },
};

export const VENITI_MANUAL_ACTIONS = {
  UPDATE_BENEFICIARY: {
    value: 'UPDATE_BENEFICIARY',
    label: 'Atualizar Beneficiário',
  },
  DISABLE_BENEFFICIARY: {
    value: 'DISABLE_BENEFFICIARY',
    label: 'Desativar Beneficiário',
  },
  UPDATE_VEHICLE: { value: 'UPDATE_VEHICLE', label: 'Atualizar Veículo' },
  DISABLE_VEHICLE: { value: 'DISABLE_VEHICLE', label: 'Desativar Veículo' },
  UPDATE_COVERAGE_PLAN: {
    value: 'UPDATE_COVERAGE_PLAN',
    label: 'Atualizar Plano de Cobertura',
  },
  REMOVE_COVERAGE_PLAN: {
    value: 'REMOVE_COVERAGE_PLAN',
    label: 'Remover Plano de Cobertura',
  },
  CANCEL_POLICY: { value: 'CANCEL_POLICY', label: 'Cancelar Apólice' },
};

export const REASONS_REFUSING_PROPOSAL = [
  { id: 1, name: 'Dados do cartão de crédito não informados' },
  { id: 2, name: 'Não envio da vistoria' },
  { id: 3, name: 'Não envio da correção da vistoria' },
  { id: 4, name: 'Não envio da documentação' },
  { id: 5, name: 'Não envio da correção da documentação' },
  { id: 6, name: 'Restrição técnica' },
  { id: 7, name: 'Proposta expirada' },
  { id: 8, name: 'Solicitada pelo segurado' },
  { id: 9, name: 'Solicitada pela corretora' },
  { id: 10, name: 'Falta de pagamento' },
  { id: 11, name: 'Cotação expirada' },
  { id: 12, name: 'Proposta recusada. Veículo com pendência(s) no documento' },
  {
    id: 13,
    name: 'Proposta recusada. Não aceitamos veículos de leilão. Decore em razão da não obtenção da tabela de referência de mercado para estes veículos',
  },
  {
    id: 14,
    name: 'Proposta recusada. Não aceitamos veículos blindados, rebaixados, e/ou com kit GNV',
  },
  {
    id: 15,
    name: 'Proposta recusada. Não aceitamos chassi (VIN) alterado. Decore em razão da não obtenção da tabela de referência de mercado para estes veículos',
  },
  {
    id: 16,
    name: 'Proposta recusada. Não aceitamos divergência de informação entre a proposta e dados do condutor',
  },
  {
    id: 17,
    name: 'Proposta recusada. Não aceitamos veículos com pendências de recall',
  },
  {
    id: 18,
    name: 'Proposta recusada. Não aceitamos referência tabela FIPE diferente do modelo do veículo',
  },
  {
    id: 19,
    name: 'Proposta recusada. Não aceitamos veículos de recuperados. Decore em razão da não obtenção da tabela de referência de mercado para estes veículos',
  },
  {
    id: 20,
    name: 'Proposta recusada. Não aceitamos veículos com avarias nos vidros',
  },
  {
    id: 21,
    name: 'Proposta recusada. Veículo com avarias com limite acima do permitido',
  },
  { id: 22, name: 'Proposta com diferença de bônus' },
];

export const MAP_PROPOSAL_STATUSES = Object.fromEntries(
  Object.values(STATUS_PROPOSTA).map(({ id, name }) => [id, name]),
);
export const MAP_POLICY_STATUSES = Object.fromEntries(
  Object.values(POLICY_STATUSES).map(({ id, name }) => [id, name]),
);
export const MAP_PAYMENT_METHODS = Object.fromEntries(
  Object.values(PAYMENT_METHODS).map(({ id, name }) => [id, name]),
);
export const MAP_REASONS_REFUSING_PROPOSAL = Object.fromEntries(
  Object.values(REASONS_REFUSING_PROPOSAL).map(({ id, name }) => [id, name]),
);

export const FUEL_TYPE_NAMES = {
  ELECTRIC: 'Elétrico',
};
export const FUEL_TYPE_CODES = {
  ELECTRIC: 'E',
};

export const REFUND_METHOD_TYPES = {
  CREDIT_CARD: 1,
  PIX: 2,
  MANUAL_CREDIT_CARD: 3,
};

export const CNSEG_CANCELLATION_REASONS = {
  CLAIM: '1',
  NON_PAYMENT: '2',
  POLICYHOLDER_BROKER_REQUEST: '3',
  OTHER_REASONS: '4',
};
